import { useMemo, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getMeterTypeName } from '../utils/meter.helpers'; 

export function useMeterFilters(rows) {
  const [searchParams] = useSearchParams();

  const [viewMode, setViewMode] = useState('list');
  const [searchQuery, setSearchQuery] = useState('');
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [filters, setFilters] = useState({
    meterNumber: [],
    unit: [],
    evn: [],
    meterType: [], 
    faulty: [],
  });

  useEffect(() => {
    const unitParam = searchParams.get('unit');
    setFilters((f) => ({
      ...f,
      unit: unitParam ? unitParam.split(',').map((s) => s.trim()) : [],
    }));
  }, [searchParams]);

  const filteredRows = useMemo(() => {
    const normalize = (v) => String(v ?? '').trim().toLowerCase();

    return rows.filter((r) => {
      if (filters.meterNumber.length &&
        !filters.meterNumber.map(normalize).includes(normalize(r.meterNumber))) return false;

      if (filters.unit.length &&
        !filters.unit.map(normalize).includes(normalize(r.unit))) return false;

      if (filters.evn.length &&
        !filters.evn.map(normalize).includes(normalize(r.evn))) return false;

      if (filters.meterType.length) {
        const label = getMeterTypeName(r.meterType);
        if (!filters.meterType.includes(label)) return false;
      }

      if (filters.faulty.length) {
        if (filters.faulty.includes('Yes') && !r.faulty) return false;
        if (filters.faulty.includes('No') && r.faulty) return false;
      }

      if (dateRange.start && dateRange.end) {
        const d = new Date(r.fromDate?.iso);
        if (d < new Date(dateRange.start) || d > new Date(dateRange.end)) return false;
      }

      if (searchQuery) {
        const haystack = `${r.meterNumber} ${r.fromDate.display} ${r.toDate.display} ${r.unit} ${r.evn} ${r.meterType}`.toLowerCase();
        if (!haystack.includes(searchQuery.toLowerCase())) return false;
      }

      return true;
    });
  }, [rows, filters, dateRange, searchQuery]);

  return {
    viewMode, setViewMode,
    searchQuery, setSearchQuery,
    dateRange, setDateRange,
    filters, setFilters,
    filteredRows,
  };
}
